import { SIDE_PHOTO_CONTENT_CARD_COMPONENT_NAME } from 'src/shared/static';
import { C13SidePhotoContentCardProps } from '../C13SidePhotoContentCard/C13SidePhotoContentCard.types';
import {
  SidePhotoContentCard,
  SidePhotoContentCardCarouselProps,
} from '@ahc-digital/component-library';
import { GetSidePhotoContentCardModel } from '../C13SidePhotoContentCard/C13SidePhotoContentCard.service';
import { C14SidePhotoContentCardCarouselProps } from './C14SidePhotoContentCardCarousel.types';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { getCheckbox, getDroplink } from 'src/shared/param-utils';

export function CreateSidePhotoContentCardCarouselModel(
  props?: C14SidePhotoContentCardCarouselProps
) {
  const { renderRichText, renderLink, renderText } = useConditionalRendering();
  const { fields, params } = props || {};
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;

  const slidesArray = isEditing
    ? []
    : props?.rendering?.placeholders?.['side-photo-content-cards-{*}']?.filter(
        ({ componentName }) =>
          !!componentName && componentName === SIDE_PHOTO_CONTENT_CARD_COMPONENT_NAME
      ) || [];

  const slides =
    slidesArray?.map((s, idx) => {
      const cta = s as unknown as C13SidePhotoContentCardProps;

      return (
        <SidePhotoContentCard
          key={idx}
          {...GetSidePhotoContentCardModel({
            props: cta,
            isEditing: sitecoreContext?.pageEditing || false,
          })}
          data-component={marketingRenderingName}
          shouldLazyLoad={getCheckbox(props?.params?.ShouldLazyLoad)}
        />
      );
    }) || [];

  const carouselProps = {
    slideTimingSeconds: params?.SlideTiming ?? '6',
    backgroundColor: getDroplink(params?.BackgroundColor, 'whiteSmoke'),
    headlineTag: getDroplink(params?.HeadlineTag, 'p'),
    layout: getDroplink(params?.SlideLayout, 'fifty'),
    ctaStyle: getDroplink(params?.CTAStyle, 'solid'),
    contentAlignment: getDroplink(params?.ContentAlignment, 'center'),
    supportCopyBottom: renderRichText(fields?.SupportCopyBottom),
    supportCopy: renderRichText(fields?.SupportCopy),
    cta: renderLink(fields?.CTA),
    headline: renderText(fields?.Headline),
    slides: slides,
  } as SidePhotoContentCardCarouselProps;
  return carouselProps;
}
